import { ChakraProvider } from "@chakra-ui/react";
import { AdvancedLoanCalculatorBlock } from "./AdvancedLoanCalculatorBlock/AdvancedLoanCalculatorBlock";
import { theme } from "./theme.config";
import languageFile from './language.json';
import { Global } from "@emotion/react";

function App() {
  //DK, SV, NO
  const currentLang = window.LOAN_CALCULATOR_LANGUAGE || 'dk';

  const getLanguageProps = () => {
    
    const lang = languageFile || {};

    let output = {};
    for(const key in lang) {
      if (lang.hasOwnProperty(key)) {
        output = {
          ...output,
          [key]: lang[key][currentLang],
        }
      }
    }

    return output;
  };

  const languageProps = getLanguageProps();

  return (
    <ChakraProvider theme={theme} resetCSS={process.env.NODE_ENV !== 'production'}>
      <AdvancedLoanCalculatorBlock
        {...languageProps}
        language={currentLang}
      />
    </ChakraProvider>
  );
}

export default App;
